<template>
    <div>
        <action-bar>
        </action-bar>
        <main class="content">
            <div v-if="card">
              <h1>Karteikarte bearbeiten<br>
                  <small class="text-muted">
                    <router-link
                      v-if="chapter && chapter.keyThemeId"
                      :to="{name: 'key-theme-chapter-list', params: {keyThemeId: chapter.keyThemeId}}" exact>
                      {{keyTheme ? keyTheme.name.text : ''}}
                    </router-link>
                    <router-link
                      v-if="chapter && chapter.dossierId"
                      :to="{name: 'dossier-edit', params: {dossierId: chapter.dossierId}}" exact>
                      {{dossier ? dossier.name.text : ''}}
                    </router-link>
                    <i class="fal fa-angle-right" v-if="chapter"></i>
                    <router-link
                      v-if="card.chapterId"
                      :to="{name: 'synthesis-sub-chapter-list', params: {chapterId: card.chapterId}}" exact>
                      {{chapter ? chapter.name.text : ''}}
                    </router-link>
                    <i class="fal fa-angle-right" v-if="card.chapterId"></i>
                    <router-link
                      v-if="card.subChapterId"
                      :to="{name: 'synthesis-card-list', params: {subChapterId: card.subChapterId}}" exact>
                      {{subChapter ? subChapter.name.text : ''}}
                    </router-link>
                    <i class="fal fa-angle-right" v-if="card.subChapterId"></i>
 
                    {{card.name.text}}</small>
              </h1>
              <ul class="nav nav-tabs">
                <li class="nav-item">
                    <router-link class="nav-link"
                                :to="{name: 'synthesis-card-edit', params: {cardId: card.id}}" exact>
                        Generelle Texte
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link"
                                 :to="{name: 'card-edit-micropage', params: {cardId: $route.params.cardId}}">
                        Micropage
                    </router-link>
                </li>
              </ul>
              <div class="tab-content">
                  <router-view class="tab-pane fade show active" :data="card" entity="card"/>
              </div>
            </div>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
export default {
  data() {
    return {
      card: null
    };
  },
  asyncComputed: {
    keyTheme () {
      if (this.card && this.card.keyThemeId) {
        return axios
          .get('/api/' + store.state.language + '/key_theme/' + this.card.keyThemeId)
          .then(({data}) => data.result)
      }
    },
    dossier () {
      if (this.card && this.card.dossierId) {
        return axios
          .get('/api/' + store.state.language + '/dossier/' + this.card.dossierId)
          .then(({data}) => data.result)
      }
    },
    chapter () {
      if (this.card && this.card.chapterId) {
        return axios
          .get('/api/' + store.state.language + '/chapter/' + this.card.chapterId)
          .then(({data}) => data.result)
      }
    },
    subChapter () {
      if (this.card && this.card.subChapterId) {
        return axios
          .get('/api/' + store.state.language + '/sub_chapter/' + this.card.subChapterId)
          .then(({data}) => data.result);
      }
    }
  },
  async mounted() {
    const {
      data: { result: card }
    } = await axios.get(
      `/api/${store.state.language}/card/${this.$route.params.cardId}`
    );

    const {
      data: { result: blocks }
    } = await axios.get(
      `/api/${store.state.language}/card/${this.$route.params.cardId}/blocks`
    );

    card.blocks = blocks;
    this.card = card;
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/synthesis/card/Edit.vue